import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
import * as _ from "lodash";
import React, { useEffect, useRef } from "react";
import "./index.scss";
const MultipleInput = ({
  className,
  filters,
  keyData,
  prevTags,
  setFilters,
  setTags,
  tags,
}) => {
  const wrapperRef = useRef(null);
  const currentTagsRef = useRef([]);
  const setFiltersRef = useRef(setFilters);
  const setTagsRef = useRef(setTags);
  const keyDataRef = useRef(keyData);

  useEffect(() => {
    if (prevTags?.length && prevTags[0]?.length && _.isArray(prevTags[0])) {
      setTags(prevTags[0]);
    }
  }, [prevTags, filters]);

  const currentTags = Array.isArray(filters?.[keyData]?.values?.[0])
    ? filters?.[keyData].values?.[0]?.length > 0 ? filters?.[keyData].values?.[0] : []
    : (typeof filters?.[keyData]?.values === 'string') ? filters?.[keyData]?.values?.split(', ') : [];

  // Keep refs in sync on every render
  currentTagsRef.current = currentTags;
  setFiltersRef.current = setFilters;
  setTagsRef.current = setTags;
  keyDataRef.current = keyData;

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const handleKeyDown = (e) => {
      if (e.keyCode === 8 || e.keyCode === 46) {
        const input = wrapper.querySelector('input');
        if (input && input.value.length > 0) {
          e.stopPropagation();
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      if (e.keyCode === 27) {
        const focused = document.activeElement;
        if (focused && focused.classList.contains('react-tag-input__tag__content') && focused.innerText.trim() === '') {
          removeEmptyTag(focused);
        }
      }
    };

    const removeEmptyTag = (target) => {
      const allTagContents = Array.from(wrapper.querySelectorAll('.react-tag-input__tag__content'));
      const index = allTagContents.indexOf(target);
      if (index !== -1) {
        const newTags = currentTagsRef.current.filter((_, i) => i !== index).map(t => t.trim());
        setTagsRef.current(newTags);
        if (setFiltersRef.current) {
          setFiltersRef.current((prev) => ({
            ...prev,
            [keyDataRef.current]: {
              ...prev[keyDataRef.current],
              values: [newTags],
            },
          }));
        }
        target.innerText = '';
      }
    };

    const handleBlur = (e) => {
      const target = e.target;
      if (target?.classList.contains('react-tag-input__tag__content') && target.innerText.trim() === '') {
        removeEmptyTag(target);
      }
    };

    wrapper.addEventListener('keydown', handleKeyDown, true);
    wrapper.addEventListener('blur', handleBlur, true);
    return () => {
      wrapper.removeEventListener('keydown', handleKeyDown, true);
      wrapper.removeEventListener('blur', handleBlur, true);
    };
  }, []);

  return (
    <div ref={wrapperRef}>
      <ReactTagInput
        className={className}
        tags={currentTags}
        placeholder="Type and press enter"
        editable={true}
        readOnly={false}
        removeOnBackspace={true}
        onChange={(newTags) => {
          const filteredTags = newTags.map(tag => tag.trim()).filter(tag => tag !== '');
          if (filteredTags.length > 500) return;
          setTagsRef.current(filteredTags);
          if (setFiltersRef.current) {
            setFiltersRef.current((prev) => ({
              ...prev,
              [keyDataRef.current]: {
                ...prev[keyDataRef.current],
                values: [filteredTags],
              },
            }));
          }
        }}
      />
    </div>
  );
};

export default MultipleInput;
